<template>
  <SoftwareFormEditor form-name="newSoftwareForm" />
</template>

<script>
import SoftwareFormEditor from "./SoftwareFormEditor.vue";

export default {
  name: "NewSoftwareForm",
  components: { SoftwareFormEditor }
};
</script>
